// removed by extract-text-webpack-plugin
module.exports = {"small":"(min-width:600px)","medium":"(min-width:768px)","large":"(min-width:1200px)","grid":"mobile__grid___t9jwz","gridItem":"mobile__gridItem___3oGJO","device":"mobile__device___2MocK","deviceContent":"mobile__deviceContent___v5EAO","deviceScreen":"mobile__deviceScreen___33sw0","img":"mobile__img___171Ay"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/mobile.css
// module id = 162
// module chunks = 0